module.exports = __webpack_public_path__ + "static/media/st-logo-blue.f690084b.svg";